export const ROUTES = {
    root: '/',
    accountants: {
        root: '/ksiegowi'
    }
}